import { useCallback, useState } from 'react';
import { Button, Card, HlsVideoPlayer, Icon, Modal } from 'ui';
import { useVideoControl } from '../../context';

type P = {
  videoPath: string;
};

const WatchVideo = ({ videoPath }: P) => {
  const [isWatchModalOpened, setIsWatchModalOpened] = useState(false);
  const { headerVideoRef } = useVideoControl();

  const openModal = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    headerVideoRef?.current?.pause();
    setIsWatchModalOpened(true);
  }, [headerVideoRef]);

  const closeModal = useCallback(() => {
    setIsWatchModalOpened(false);
  }, []);

  return (
    <>
      <Card>
        <Button block icon={<Icon icon="play-line" />} onClick={openModal} type="primary">
          Watch
        </Button>
      </Card>
      <Modal closable={false} isOpened={isWatchModalOpened} onCancel={closeModal}>
        <HlsVideoPlayer video={{ src: videoPath }} />
      </Modal>
    </>
  );
};

export default WatchVideo;
